import React from 'react'
import OrgSelector from './OrgSelector'

const Navbar: React.FC = () => {
  return (
    <header className="h-16 bg-background-secondary border-b border-zinc-700 flex items-center justify-between px-6">
      <div className="flex items-center gap-4">
        <h2 className="text-lg font-semibold text-text-primary">
          {/* Page title will be set by individual pages */}
        </h2>
      </div>

      <div className="flex items-center gap-4">
        <OrgSelector />
      </div>
    </header>
  )
}

export default Navbar
